import React, { useEffect, useRef } from 'react'
import styled from 'styled-components'
import Form from 'react-bootstrap/Form'
import Button from 'react-bootstrap/cjs/Button'
import { _ } from '../../../utils/localization'
import Icon from '../../../components/Icon'
import colors from '../../../constants/colors'

const S = {
    Form: styled(Form)`
        display: flex;
        align-items: center;
        justify-content: space-between;
        border-top: ${colors.dividerColor} solid 1px;
    `,
    HorizontalBorder: styled.div` 
        height: 100%;
        top: 0;
        bottom: 0;
    `,
    LeftBoarderWrapper: styled.div`
        border-left: ${colors.dividerColor} solid 1px;
    `,
    SendButton: styled(Button)`
        background-color: transparent !important;  // important to disable hover
        border-color: transparent;
        padding: 10px;
    `,
    Input: styled(Form.Control)`
        border: 0;
        padding: 10px;
        margin-left: 4px;
        margin-right: 4px;
    `,
    CardHeader: styled.div`
        display: flex;
        align-items: center;
        justify-content: space-between;
        color: ${colors.gray6};
        font-weight: bold;
    `,
}

interface MessageInputProps {
    send: (text: string) => void
}

const MessageInput = ({ send }: MessageInputProps) => {
    const [value, setValue] = React.useState('')
    const inputRef = useRef<HTMLInputElement>()
    useEffect(() => {
        inputRef.current.focus()
    }, [])

    const submit = (event: Event | undefined) => {
        if (event) {
            event.preventDefault()
        }
        if (value !== '') {
            send(value)
            setValue('')
        }
    }
    return (
        <S.Form onSubmit={submit}>
            <S.Input
                type="text"
                placeholder={_('chat.new_message_input.placeholder')}
                value={value}
                onChange={(e) => setValue(e.target.value)}
                ref={inputRef}
            />
            <S.LeftBoarderWrapper>
                <S.SendButton onClick={submit}>
                    <Icon icon="send" />
                </S.SendButton>
            </S.LeftBoarderWrapper>
            <input style={{ display: 'none' }} type="submit" />
        </S.Form>
    )
}

export default MessageInput
